// extracted by mini-css-extract-plugin
export default {"login-header":"MobileMinimalNavigation-u1guH__login-header","nav-button":"MobileMinimalNavigation-Om9q3__nav-button"};